import { setLocale } from 'yup';

setLocale({
  mixed: {
    required: 'Campo Obrigatório',
  },
});
